import { Pipe, PipeTransform } from '@angular/core';
import { formatCpf } from '../../utils';

@Pipe({
  name: '_cpf',
  pure: true,
  standalone: false,
})
export class CpfPipe implements PipeTransform {
  public transform(value: string): any {
    if (!value) {
      return;
    }
    return formatCpf(value);
  }
}
